"use client";

import { cn } from "@punchup/utils";
import { useShowRowContext } from "@/components/shows/ShowRowContext";

interface ShowRowCardWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export function ShowRowCardWrapper({
  children,
  className,
}: ShowRowCardWrapperProps) {
  const { hideComedianName, isNearby } = useShowRowContext();

  const baseClassName =
    "border-[0.5px] rounded-lg shadow-[0_0_4px_rgba(72,72,72,0.25)]";

  return (
    <div
      className={cn(
        baseClassName,
        isNearby && hideComedianName
          ? "border-[rgb(255,107,53)]"
          : "border-transparent",
        className
      )}
    >
      {children}
    </div>
  );
}
